import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';

export const AutoFillInputStyles = css`
  ${MainStyles}
  :host {
    position: relative;
    height: auto;
    contain: none;
    display: flex;
    flex-direction: column;
  }

  .autofill-wrapper {
    width: 100%;
  }

  zero-text-field {
    width: 100%;
  }

  .list-container {
    position: absolute;
    width: 100%;
    min-height: 150px;
    background: rgb(66, 77, 83);
    border: 1px solid var(--rapid-ag-border-color);
    border-radius: 4px;
    padding: 4px 0;
    z-index: 1;
    overflow-x: auto;
  }

  .list-container:has(.no-match) {
    min-height: 31px;
  }

  .list-item {
    background-color: rgb(31, 33, 38);
    border: 1px solid rgb(46, 51, 57);
    cursor: pointer;
    line-height: 20px;
    padding: 7px;
  }

  .list-item:hover {
    background-color: var(--neutral-fill-stealth-hover);;
  }

  .list-item.selected {
    background-color: rgb(20, 21, 25);
  }

  .list-item.no-match:hover {
    background-color: rgb(31, 33, 38);
    cursor: auto;
  }
`;
